import { useEffect, useState, useMemo } from 'react';
import { Container } from './styled';
import { Card } from './components/Card';
import { useChat } from '../../../../../../contexts/chat';
import {
    SelectMultipleCustomerService
} from '../../../../../../components';

export function My(props) {

    const { isVisibility } = props
    const {
        myChatsOpen,
        handleMyChats,
        customer,
        onFilter,
        resetChat,
        idChat
    } = useChat()

    const [dataCustomer, setDataCustomer] = useState({})
    const [selectedCustomer, setSelectedCustomer] = useState({
        isOpen: false,
        customerServicersID: []
    });

    useEffect(() => {
        if (!isVisibility) return
        if (!myChatsOpen) return
        const isChatOpen = myChatsOpen?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [myChatsOpen]);
    
    useEffect(() => {
        handleMyChats()
    }, [])
    useEffect(() => {
        if (typeof customer !== 'string') return setDataCustomer(customer);
        return setDataCustomer(JSON.parse(customer));
    }, [customer]);
    const allIDS = myChatsOpen?.map((item) => item.id);
    const onSelectedCustomer = (id) => {
        setSelectedCustomer(prev => {
            const updatedCustomerServicersID = prev.customerServicersID.includes(id)
                ? prev.customerServicersID.filter(item => item !== id)
                : [...prev.customerServicersID, id];
            return {
                ...prev,
                customerServicersID: updatedCustomerServicersID
            };
        });
    };
    const handleSelectedAll = (e) => {
        if (e) {
            setSelectedCustomer({
                isOpen: true,
                customerServicersID: allIDS
            });
            return
        }
        setSelectedCustomer({
            isOpen: true,
            customerServicersID: []
        });
    };

    const visibleData = myChatsOpen.filter(
        (e) => {
            return onFilter(e, 1)
        }
    )
    const myStateElements = useMemo(() => visibleData
        ?.map((item, key) => (
            <Card
                key={item.id}
                data={item}
                active={dataCustomer?.id === myChatsOpen[key].id}
                loadChats={handleMyChats}
                onSelectedCustomer={onSelectedCustomer}
                selectedCustomer={selectedCustomer}
            />
        )), [visibleData, selectedCustomer]
    );

    return (
        <Container visibility={isVisibility ? 1 : 0}>
            {myChatsOpen.length !== 0 && (
                <SelectMultipleCustomerService
                    isOpen={selectedCustomer.isOpen}
                    customersSelected={selectedCustomer.customerServicersID}
                    customerServicesAll={allIDS?.length}
                    onClose={() => {
                        setSelectedCustomer({
                            isOpen: false,
                            customerServicersID: []
                        })
                    }}
                    onOpen={() => {
                        setSelectedCustomer({
                            isOpen: true,
                            customerServicersID: []
                        })
                    }}
                    onSelectAll={(e) => {
                        handleSelectedAll(e)
                    }}
                    actions={{
                        initialize: false,
                        transfer: false,
                        finish: true
                    }}
                />
            )}
            {myStateElements}
        </Container>
    );
}   